import React, { useContext, useEffect, useState } from 'react'
import { Container } from 'reactstrap'
import { showTopbarInsideAction } from '../../store/actions'
import { useDispatch, useSelector } from 'react-redux'
import HeaderDefaultToPage from '../../components/Common/headerDefaultToPage'
import { Link } from 'react-router-dom'
import {
  PLATAS_DA_EMPRESA,
  USUARIOS_CADASTRADOS,
  MEUS_PARCEIROS
} from '../../helpers/routes_helper'
import { CardGridCustom } from '../../components/Common/CardGridCustom'
import { Skeleton } from 'primereact/skeleton'
import { AuthProtectedContext } from '../../Routes/AuthProtectedContext'
import { fnGetValueByKey } from '../../helpers/functions'

const BI_WS0010 = () => {
  document.title = 'Defender | Configurações da Empresa'

  const dispatch = useDispatch()

  const { transactionData } = useContext(AuthProtectedContext);
  const { isIframePage } = useSelector(state => ({
    isIframePage: state.Layout.isIframePage
  }))

  const [loading, setLoading] = useState(true)
  const [error, ] = useState(false)

  const [empresas, setEmpresas] = useState([])
  const [usuarios, setUsuarios] = useState([])
  const [parceiros, setParceiros] = useState([])

  const [totalUsuarios, setTotalUsuarios] = useState(0)
  const [totalParceiros, setTotalParceiros] = useState(0)
  const [totalEmpresas, setTotalEmpresas] = useState(0)

  useEffect(() => {
    dispatch(showTopbarInsideAction({}))
  }, [dispatch])

  useEffect(() => {
    let data = fnGetValueByKey(transactionData, "PROCEDURE_RESULTSET")
    try {
      data = JSON.parse(data)
      
      const empresasData = data && data[0]?.Conteudo && JSON?.parse(data[0]?.Conteudo) || []
      const usuariosData = data && data[1]?.Conteudo && JSON?.parse(data[1]?.Conteudo) || []
      const parceirosData = data && data[2]?.Conteudo && JSON?.parse(data[2]?.Conteudo) || []
      const totais = data && data[3]?.Conteudo && JSON?.parse(data[3]?.Conteudo) || []

      setEmpresas(empresasData)
      setLoading(false)
      setUsuarios(
        usuariosData.sort((a, b) =>
          (a.Nome_Completo || a.Nome_Usuario || '').localeCompare(
            b.Nome_Completo || b.Nome_Usuario || ''
          )
        )
      )
      setParceiros(parceirosData)

      const getTotal = nome =>
        parseInt(
          (
            totais.find(t => t.Nome_Totalizador === nome)?.Valor_Formatado ||
            '0'
          ).replace(/\./g, ''),
          10
        )

      setTotalEmpresas(getTotal('["TOTAL_EMPRESAS"]'))
      setTotalUsuarios(getTotal('["TOTAL_USUARIOS"]'))
      setTotalParceiros(getTotal('["TOTAL_PARCEIROS"]'))
    } catch (error) {
      console.warn("Erro ao parsear PROCEDURE_RESULTSET:", error);
    }

  }, [transactionData])

  const getFotoUsuarioURL = foto => {
    try {
      const parsed = JSON.parse(foto)
      if (Array.isArray(parsed) && parsed.length > 0) {
        const url = parsed[0].valor
        return url?.startsWith('data:image') ? url : null
      }
    } catch (e) {
      console.error('Erro ao parsear Foto_Usuario:', e)
    }
    return null
  }

  return (
    <div className={`page-content page-config page-config-business ${isIframePage && 'is-iframe-content'}`}>
      <Container fluid className="dataTable-custom-primary">
        {loading ? (
          <Skeleton width={400} height={50} />
        ) : (
          <HeaderDefaultToPage
            title="Configurações da Empresa"
            goBack={false}
          />
        )}

        {loading || !empresas.length || !usuarios.length || !parceiros.length ? (
          <div className="d-flex gap-3 my-4 flex-wrap content-page">
            <Skeleton className="col" height="280px" />
            <Skeleton className="col" height="280px" />
            <Skeleton className="col" height="280px" />
          </div>
        ) : error ? (
          <div className="alert alert-danger" role="alert">
            Erro ao buscar dados do servidor.
          </div>
        ) : (
          <div className="d-flex gap-3 my-4 flex-wrap content-page">
            <CardGridCustom
              title="Minha Empresa/Filiais"
              notifyNumber={totalEmpresas}
              paddingTitle="mb-2"
            >
              <ul className="ul-list-custom">
                {empresas.length > 0 ? (
                  empresas.map((empresa, idx) => (
                    <li key={idx} className="border-bottom">
                      <Link to={PLATAS_DA_EMPRESA}>
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="img-card d-flex align-items-center gap-2">
                            {empresa.Icone && <i style={{fontSize: '25.6px'}}
                              className={`${empresa.Icone}`}
                            ></i> }
                            <span>
                              {empresa.Descricao_Planta_Tipo || 'Não Definido'}
                            </span>
                          </div>
                          <span className="font-w-400 text-color-cinza4">
                            {empresa.Qtde}
                          </span>
                        </div>
                      </Link>
                    </li>
                  ))
                ) : (
                  <li className="border-bottom text-muted">
                    Nenhuma empresa encontrada
                  </li>
                )}
              </ul>
              <Link to={PLATAS_DA_EMPRESA} className="btn-link-page">
                Visualizar mais informações
              </Link>
            </CardGridCustom>

            <CardGridCustom
              title="Usuários Cadastrados"
              notifyNumber={totalUsuarios}
              paddingTitle="mb-2"
            >
              <ul className="ul-list-custom">
                {usuarios.length > 0 ? (
                  usuarios.slice(0, 4).map((user, idx) => {
                    const fotoURL = getFotoUsuarioURL(user.Foto_Usuario)
                    return (
                      <li key={idx} className="border-bottom">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-2">
                            <div>
                              {fotoURL ? (
                                <img
                                  src={fotoURL}
                                  alt={user.Nome_Completo || 'Usuário'}
                                  className="img-context-user"
                                  style={{
                                    width: '31px',
                                    height: '32px',
                                    objectFit: 'cover',
                                    borderRadius: '50%',
                                    flexShrink: 0,
                                    display: 'block'
                                  }}
                                />
                              ) : (
                                <i className="font-size-32 user-photo-label far fa-user-circle text-secondary"></i>
                              )}
                            </div>
                            <span>
                              {user.Nome_Completo ||
                                user.Nome_Usuario ||
                                'Usuário Desconhecido'}
                            </span>
                          </div>
                          <span className="font-size-13 font-w-400">
                            {user.Cargo || user.Departamento || ''}
                          </span>
                        </div>
                      </li>
                    )
                  })
                ) : (
                  <li className="border-bottom text-muted">
                    Nenhum usuário encontrado
                  </li>
                )}
              </ul>
              <Link to={USUARIOS_CADASTRADOS} className="btn-link-page">
                Visualizar mais informações
              </Link>
            </CardGridCustom>

            <CardGridCustom
              title="Meus Parceiros de Negócios"
              notifyNumber={totalParceiros}
              paddingTitle="mb-2"
            >
              <ul className="ul-list-custom">
                {parceiros.length > 0 ? (
                  parceiros.map((p, idx) => (
                    <li key={idx} className="border-bottom">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          {p.Icone && <i style={{fontSize: '25.6px'}}
                            className={`${p.Icone}`}
                          ></i> }
                          <span>
                            {p.Descricao_Tipo_Relacao ||
                              'Parceiro Desconhecido'}
                          </span>
                        </div>
                        <span className="text-color-cinza4 font-w-400">
                          {p.Qtde || ''}
                        </span>
                      </div>
                    </li>
                  ))
                ) : (
                  <li className="border-bottom text-muted">
                    Nenhum parceiro encontrado
                  </li>
                )}
              </ul>
              <Link to={MEUS_PARCEIROS} className="btn-link-page">
                Visualizar mais informações
              </Link>
            </CardGridCustom>
          </div>
        )}
      </Container>
    </div>
  )
}

export default BI_WS0010
